import Select from '@components/select';
import { OptionType } from '@components/select/dist/types';
import { observer } from 'mobx-react-lite';

import { Field } from 'components/Field';
import { useStore } from 'hooks/useStore';
import { SelectInputRenderData } from 'types/@components/common';

import css from './VatRatesSelect.module.css';

const DISPLAYABLE_COUNT = 3;
const DROPDOWN_WIDTH = 236;

const renderSuggestion = (suggestion: OptionType) => (
  <div className={css.suggestion}>
    <span>{suggestion.label}</span>
    {suggestion.description && <span className={css.suggestionDescription}>{suggestion.description}</span>}
  </div>
);

const renderInputValue = (
  _data: SelectInputRenderData,
  selected: OptionType[],
  allCount: number,
  allRatesLabel: string,
) => {
  if (!selected.length || selected.length === allCount) {
    return <span className={css.inputValue}>{allRatesLabel}</span>;
  }

  const sorted = selected.map(o => o.value as number).sort((a, b) => a - b);
  const percents = sorted.slice(0, DISPLAYABLE_COUNT).map(n => `${n}%`);
  const rest = selected.length - DISPLAYABLE_COUNT;

  return (
    <>
      <span className={css.inputValue}>{percents.join(', ')}</span>
      {rest > 0 && <span className={css.inputValue}>+{rest}</span>}
    </>
  );
};

const VatRatesSelect = () => {
  const {
    app: { i18n, locale },
    ui: { vatRatesDisplay },
  } = useStore();

  const { allOptions, selectedOptions, selectOption } = vatRatesDisplay;

  return (
    <div className={css.wrapper}>
      <Field isRow contentClassName={css.fieldContent} labelText={i18n.vatRates.label}>
        <Select
          isMulti
          dropdownWidth={{ min: DROPDOWN_WIDTH, max: DROPDOWN_WIDTH }}
          labelProperty="label"
          locale={locale}
          multiValue={selectedOptions}
          options={allOptions}
          placeholder={i18n.vatRates.allRates}
          renderInputValue={(data: SelectInputRenderData) =>
            renderInputValue(data, selectedOptions, allOptions.length, i18n.vatRates.allRates)
          }
          renderSuggestion={renderSuggestion}
          strings={{
            [locale]: {
              removeAll: i18n.vatRates.allRates,
            },
          }}
          usePortal={false}
          valueProperty="value"
          onMultiChange={selectOption}
        />
      </Field>
    </div>
  );
};

const connected = observer(VatRatesSelect);

export { connected as VatRatesSelect };
